<template>
  <div class="container">
    <van-nav-bar
      title="客户信息"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="box">
      <van-field center readonly label="客户手机：" :value="khInfo.mobile" >
        <template #button>
            <a :href="'tel:'+khInfo.mobile"><van-icon class="phone" name="phone-o" /></a>
        </template>
      </van-field>
      <van-field center readonly label="客户姓名：" :value="khInfo.name" />
      <van-field center readonly label="联系结果：" :border="false" placeholder="" />
      <div class="btnbox flex">
        <div @click="changeResult(true)" :class="khInfo.isIntention?'btnitem btnActive':'btnitem'">有意向</div>
        <div @click="changeResult(false)" :class="!khInfo.isIntention?'btnitem btnActive':'btnitem'">无意向</div>
      </div>
      <van-field v-model="khInfo.remark" rows="2" autosize type="textarea" label="备注：" placeholder="请输入备注" />
      <div class="pbox">
        <van-button block round type="info" @click="isTeled" >完成</van-button>
      </div>
      
      <!-- <div class="fl_right tel">
        <a :href="'tel:'+khInfo.mobile">
          <img @click="isTeled" src="../assets/img/phone.png" alt="">
        </a>
      </div> -->
    </div>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Toast,Loading,Button,Field} from 'vant';
  export default {
    data() {
      return {
        khInfo:{}
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Button.name]:Button,
      [Field.name]:Field,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html"})
      },
      onClickLeft() {
        this.$router.go(-1)
      },
      changeResult(type){
        this.khInfo.isIntention = type;
      },
      getKHInfo(){
        var id = this.$route.query.rowId;
        axios.get("/custominformation/getcustominfomation?customInfomationId="+id,{}).then((res)=>{
          this.khInfo = res.data;
        })
      },
      isTeled(){
        axios.post("/custominformation/update",{
          id: this.khInfo.id,
          isEnabled: true,
          isIntention: this.khInfo.isIntention,
          remark: this.khInfo.remark
        }).then((res)=>{
          if(res.isSuccess){
            Toast('提交成功');
            setTimeout(()=>{
              this.onClickLeft();
            },1500)
          }
        })
      },
    },
    computed:{
    },
    created () {
      this.getKHInfo();
    },
    mounted () {},
    destroyed () {}
  }
</script>

<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #fff}
  .container{
    width: 100%;min-height: 100vh;letter-spacing:0px;background: #F0F4F7;
  }
  .box{
    width: 100%;
    padding-top: 16px;
    box-sizing: border-box;
    .item{
      margin: 16px 0;
      font-size: 16px;
      .lab{
        display: inline-block;
        width: 100px;
      }
    }
  }
  .tel img{
    width: 60px;
  }
  .btnbox{
    padding: 0 50px 20px 115px;
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 16px;
    .btnitem{
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 6px;
      background: #fff;
      border: 1px solid #ccc;
      box-sizing: border-box;
    }
  }
  .btnActive{
    background: #1989fa !important;
    border: 1px solid #1989fa;
    color: #fff;
  }
  .pbox{
    padding: 26px 100px;
  }
  .phone{
    vertical-align: bottom;
    font-size: 26px;
  }
</style>
